import { infoCard } from "./info-card";
import { drawers } from "./drawers";
import { modalPlaces } from "./modal-places";
import { modalDelete } from "./modal-delete";
import { validation } from "./validation";

export const components = {
	drawers,
	infoCard,
	modalPlaces,
	modalDelete,
	validation,
};
